<template>
  <div>
    <div class="m-background m-background--media-1"></div>
      <div id="reset-wrapper"><a @click="showConfirm = true"><img src="../../assets/images/icons/home.png" class="full-logo"></a></div>
      <ConfirmReset v-if="showConfirm" @close="showConfirm = false"></ConfirmReset>
      <VideoIntro v-if="showVideoIntro" @close="showVideoIntro = false" :url='studentByName.video'></VideoIntro>
    <div class="l-container">
      <div class="l--intros-left">
        <h2>{{ studentByName.name | capitalize}}</h2>

        <p><strong>Name:</strong> {{ studentByName.name | capitalize }}</p>
        <p><strong>Age:</strong> {{ studentByName.age }}</p>
        <p><strong>Studying:</strong> {{ studentByName.studying }}</p>
        <p><strong>Can be heard saying:</strong> {{ studentByName.catchphrase }}</p>
        <p><strong>Profile:</strong> {{ studentByName.profile }}</p>

          <div class="l--intros--student"
            v-for="student in getStudents"
            :key="student.id">
              <router-link class="m-btn m-btn--left m-btn__primary"
              :to="{ name: 'intro', params: {id: student.name } }">
              {{ student.name | capitalize }}<span class="m-btn__arrow__s" style="display:inline-block; margin-top: -0.4em;"></span>
              </router-link>
            <img :src='student.smallimage'>
          </div>
        <!--<div class="back-btn"><router-link :to="{ name: 'intros' }"><span class="m-btn m-btn__arrow-left" style="display:inline-block; margin-top: -0.4em;"></span>Back to students</router-link></div>-->
        <router-link :to="{ name: 'reception' }" class="m-btn m-btn--left m-btn__secondary m-rooms">See the rooms &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></router-link>
      </div>
      <img :src='studentByName.image' class="student-image">
      <div class="l--color-bg">
        <div class="p-video">
          <div class="p-speaker"></div>
          <div class="p-frame" v-bind:style="{ backgroundImage: 'url(' + studentByName.frame + ')' }">
            <div @click="showVideoIntro = true"><div class="play-student"></div></div>
          </div>
          <div class="p-home"></div>
        </div>
      </div>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Brand from '../../components/Brand'
import VideoIntro from '../../components/VideoIntro'
import MainFooter from '../../components/MainFooter'
import ConfirmReset from '../../components/ConfirmReset'

export default {
  data () {
    return {
      thisStudent: this.$route.params.id,
      showVideoIntro: false,
      showConfirm: false
    }
  },
  computed: {
    ...mapGetters(['getStudents']),
    ...mapGetters(['getStudent', 'getStudentByName']),
    student () {
      const studentID = parseInt(this.thisStudent, 10)
      return this.getStudent(studentID)
    },
    studentByName () {
      const studentName = this.thisStudent
      return this.getStudentByName(studentName)
    }
  },
  components: {
    Brand,
    VideoIntro,
    MainFooter,
    ConfirmReset
  },
  name: 'Intro'
}
</script>

<style scoped lang='scss'>
span {
  text-transform: uppercase;
}
.l-container {
  display: flex;
  justify-content: space-between;
}
.l--intros-left h2 {
  margin:0;
}
.l--intros-left p {
}
.p-speaker {
  width: 80px;
  height: 10px;
  border-radius: 10px;
  background: #333;
  margin: 20px auto;
}
.p-frame {
  /*> div {
    cursor: pointer;
    align-self: center;
    color: rgba(255, 255, 255, 1);
    animation: glowing 5000ms infinite;
    &:hover {
      animation-name: none;
    }
  }*/
}

.p-home {
  width: 70px;
  height: 18px;
  border-radius: 10px;
  background: #333;
  margin: 15px auto;
}
.l--color-bg {
  width: 45%;
  margin:100px 0 0 0;
}
.l--header {
  width: 100%;
  padding: 0px 0px 0px 20px;
  z-index:1;
  h4 {
    display: block;
    margin: 25px 0px 25px 20px;
  }
}
.m-rooms {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
/*.back-btn {
  text-transform: uppercase;
  font-size: 1.5rem;
  padding: 0.4em 0em 0em;
  a {
    color: #000;
  }
}*/

.l--intros .m-btn {opacity:0.5;}
.m-btn.router-link-active {opacity:1;}

@media (max-width: 899px) {
  .student-image {display:none;}
  .unite-logo {width:125px;}
  h2 {font-size:1.6rem;}
  .l--color-bg {width: 45%;margin:60px 0 0 0;}
  .l--intros-left {width:80%;}
  .p-video {margin-right:120px;padding-top:0;margin-top:-30px;}
  .p-home {width: 25px;height: 10px;border-radius: 5px;background: #333;margin: 8px auto;}
  .p-speaker {width: 40px;height: 6px;border-radius: 5px;background: #333;margin: 8px auto;}
    .l--intros--student {
    &:nth-of-type(1) {
    left: 1%;
      }
      &:nth-of-type(2) {
        margin-left: 15%;
      }
      &:nth-of-type(3) {
        margin-left: 28%;
      }
      &:nth-of-type(4) {
        left: 43%;
      }
  }

  }

</style>



// WEBPACK FOOTER //
// src/views/introductions/Intro.vue